import Price from '@/components/elements/Price';
import { useTranslations } from 'use-intl';

export const VaultHeaderFloorPrice = ({
  floorPrice,
}: {
  floorPrice: bigint | undefined;
}) => {
  const t = useTranslations('CreateVault.DetailsHeader');
  return (
    <div className="ml-auto pl-0 sm:pl-4 text-left sm:text-right font-medium">
      <h4 className="text-gray-500">{t('floorPrice')}</h4>
      <Price value={floorPrice ?? 0n} />
    </div>
  );
};
